import { Team } from "project-simple-server-open-api/client/models/Team"

import {
  Epic,
  IdeaStatus,
  Item,
  ItemStatus,
  ItemType,
  Status,
  TaskType,
  Type,
  User
} from "@/models"
import { ResourceType } from "@/models/common"
import { getMilestoneTitle, renderMilestoneName } from "@/models/Milestone"
import { ReferenceType } from "@/plugins/extensions/ReferenceType"
import { formatDate } from "@/utils/dateUtil"
import { parsePrefix } from "@/utils/helpers"

export interface SearchResult {
  id: string
  resourceType: ResourceType
  textPreview: string
  type: ReferenceType
}

export interface SearchItemResult {
  id: string
  title: string
  itemType: ItemType
  sequenceNumber: number
  status: ItemStatus
  projectId: string
  statusParsed: Status
  itemTypeParsed: Type
}

export interface SearchIdeaResult {
  id: string
  projectId: string
  title: string
  sequenceNumber: number
  status: IdeaStatus
  deleted: boolean
}

export class SearchProjectResult {
  id = ""
  name = ""
  urlName = ""
  prefix = ""
  accountId = ""

  constructor(props?: Partial<SearchProjectResult>) {
    if (!props) return
    Object.keys(props).forEach(field => {
      this[field] = props[field]
    })
    this.prefix = this.prefix ? this.prefix : parsePrefix(this.name)
  }
}

export class SearchSprintResult {
  id = ""
  startDate = ""
  endDate = ""
  projectId = ""
  sequenceNumber = ""
  status = ""
  team?: Team

  constructor(props?: Partial<SearchSprintResult>) {
    if (!props) return
    Object.keys(props).forEach(field => {
      this[field] = props[field]
    })
  }

  get formatedDateStart() {
    return this.startDate ? formatDate(this.startDate, "dd MMM", { dateOnly: true }) : ""
  }

  get formatedDateEnd() {
    return this.endDate ? formatDate(this.endDate, "dd MMM", { dateOnly: true }) : ""
  }
}

export class SearchMilestoneResult {
  id = ""
  title = ""
  startDate = ""
  endDate = ""
  projectId = ""
  projectName = ""

  constructor(props?: Partial<SearchMilestoneResult>) {
    if (!props) return
    Object.keys(props).forEach(field => {
      this[field] = props[field]
    })
    this.title = getMilestoneTitle(this.title)
  }

  get titleParsed() {
    return renderMilestoneName(this.title)
  }
}

export interface SearchTaskResult {
  id: string
  name: string
  order: number
  type: TaskType
  estimatedHours?: number
}

export interface SearchPayload {
  text: string
  resourceTypes: ResourceType
  projectId?: string
  includeDemo?: boolean
}

export interface ReferencedResourcePreviews {
  epics: Epic[]
  ideas: SearchIdeaResult[]
  items: Item[]
  milestones: SearchMilestoneResult[]
  projects: SearchProjectResult[]
  sprints: SearchSprintResult[]
  users: User[]
  tasks: SearchTaskResult[]
}
